document.documentElement.classList.remove('no-js');

const qs = (selector, scope = document) => scope.querySelector(selector);
const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

qsa('[data-localization-select]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});


// GBX ONE v1.15 — Shopify-compatible locale switching.
qsa('[data-language-option]').forEach((option) => {
  option.addEventListener('click', () => {
    const form = option.closest('form');
    const input = form ? qs('[data-language-input]', form) : null;
    if (!form || !input) return;
    input.value = option.dataset.value;
    form.submit();
  });
});

const drawer = qs('[data-mobile-drawer]');
const openDrawer = qs('[data-open-drawer]');
const closeDrawer = qs('[data-close-drawer]');
const backdrop = qs('[data-drawer-backdrop]');

function setDrawer(open) {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  document.documentElement.style.overflow = open ? 'hidden' : '';
  openDrawer?.setAttribute('aria-expanded', String(open));
}
openDrawer?.addEventListener('click', () => setDrawer(true));
closeDrawer?.addEventListener('click', () => setDrawer(false));
backdrop?.addEventListener('click', () => setDrawer(false));

const searchDialog = qs('[data-search-dialog]');
qsa('[data-open-search]').forEach((button) => {
  button.addEventListener('click', () => {
    if (searchDialog?.showModal) {
      searchDialog.showModal();
      setTimeout(() => qs('input[type="search"]', searchDialog)?.focus(), 20);
    }
  });
});
qs('[data-close-search]')?.addEventListener('click', () => searchDialog?.close());

searchDialog?.addEventListener('click', (event) => {
  const rect = searchDialog.getBoundingClientRect();
  const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  if (outside) searchDialog.close();
});

qsa('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const form = select.closest('form');
    const optionSelectors = qsa('[data-variant-select]', form);
    const dataEl = qs('[data-product-variants]', form);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const selected = optionSelectors.map((el) => el.value);
    const variant = variants.find((item) => item.options.every((opt, i) => opt === selected[i]));
    const idInput = qs('input[name="id"]', form);
    const submit = qs('[type="submit"]', form);
    if (variant && idInput) idInput.value = variant.id;
    if (submit) {
      submit.disabled = !variant?.available;
      submit.textContent = variant?.available ? submit.dataset.addText : submit.dataset.soldText;
    }
  });
});

qs('[data-sort-by]')?.addEventListener('change', (event) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.assign(url.toString());
});

// GBX ONE v1.1: subtle motion, sticky-header state and language popover behavior.
const siteHeader = qs('[data-site-header]');
const syncHeaderState = () => siteHeader?.classList.toggle('is-scrolled', window.scrollY > 8);
syncHeaderState();
window.addEventListener('scroll', syncHeaderState, { passive: true });

qsa('[data-language-switcher]').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (!details.open) return;
    qsa('[data-language-switcher]').forEach((other) => {
      if (other !== details) other.removeAttribute('open');
    });
  });
});

document.addEventListener('click', (event) => {
  qsa('[data-language-switcher][open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.documentElement.classList.add('js-reveal-enabled');
  const revealItems = qsa('.gbx-hero__copy, .gbx-hero__media, .section-heading, .category-card, .product-card, .value-prop, .editorial, .newsletter-box, .site-footer__grid');
  revealItems.forEach((item) => item.classList.add('gbx-reveal'));
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
  revealItems.forEach((item) => revealObserver.observe(item));
}


// GBX ONE v1.16 — explicit data-policy consent validation.
qsa('[data-policy-consent]').forEach((wrapper) => {
  const checkbox = qs('input[type="checkbox"]', wrapper);
  const error = qs('.gbx-data-consent__error', wrapper);
  if (!checkbox) return;

  const syncConsent = () => {
    const invalid = !checkbox.checked;
    wrapper.classList.toggle('is-error', invalid);
    if (error) error.hidden = !invalid;
  };

  checkbox.addEventListener('change', () => {
    if (checkbox.checked) {
      wrapper.classList.remove('is-error');
      if (error) error.hidden = true;
    }
  });

  const form = checkbox.closest('form');
  form?.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (submitter?.hasAttribute('formnovalidate')) return;
    if (!checkbox.checked) {
      event.preventDefault();
      syncConsent();
      checkbox.focus({ preventScroll: true });
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
});
